import SideloadService from "services/SideloadService";
import { observeLazyImages } from "lazy";
import { formatDates } from "elements/date";

(() => {
  const sideloadTeasers = document.querySelectorAll(".js-wm-ajax");
  const teasers = {};

  [...sideloadTeasers].forEach((ajaxTeaser) => {
    const { ajax } = ajaxTeaser.dataset;

    if (!(ajax in teasers)) {
      teasers[ajax] = [];
    }

    teasers[ajax] = [...teasers[ajax], ajaxTeaser];
  });

  Object.keys(teasers).forEach((url) => {
    const sideloadByUrl = async () => {
      const teaserHtml = await SideloadService.sideloadByUrl(url);

      teasers[url].forEach((el) => {
        const element = el;

        element.outerHTML = teaserHtml;
      });

      observeLazyImages();
      formatDates();
    };

    sideloadByUrl();
  });
})();
